import React from 'react'

const EditIcon = () => {
    const svgPaintStyle: React.CSSProperties = {
        paintOrder: "stroke markers fill",
    };
    return (


        <svg className='edit-icon' id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 495.29 495.26">
            <defs>
                <style>
                    {`
      .cls-11 {
        stroke-width: 30px;
      }

     

      .cls-11, .cls-21, .cls-31 {
        fill: none;
      }

      .cls-11, .cls-31 {
        stroke-miterlimit: 15.12;
      }

      .cls-2 {
        stroke-miterlimit: 15.12;
        stroke-width: 30px;
      }

      
      
      `}

                </style>
            </defs>
            <path className="cls-31" d="M407.51,277.76v181.1c0,10.44-8.46,18.9-18.9,18.9H36.4c-10.44,0-18.9-8.46-18.9-18.9V106.66c0-10.44,8.46-18.9,18.9-18.9h181.11" />
            <rect className="cls-21" x="178.19" y="137.07" width="270.01" height="90" transform="translate(-37.01 274.79) rotate(-45)" />
            <path className="cls-11" d="M185.91,245.71l63.64,63.64-7.89,7.89-89.8,26.16,26.16-89.8,7.89-7.9Z" />
            <path className="cls-11" d="M450.56,23.86l20.88,20.88c11.81,11.81,11.81,30.95,0,42.76l-30.95,30.95-63.64-63.64,30.95-30.95c11.81-11.81,30.95-11.81,42.76,0h0Z" />
        </svg>

    )
}

export default EditIcon
